<template>
  <div class="workspace-grid workspace">
    <div class="ack">
      <h2>Integrated Methods, Tools and Databases</h2>

    <div class="dakrlist">
      <div class="list">
        <h4>DSSP (hydrogen bond estimation algorithm)</h4>

        DSSP algorithm is the standard method for assigning secondary structure to the amino acids of a protein, given the atomic-resolution coordinates of the protein.
        <ul>
          <li>Reference 1: <a href=http://www.ncbi.nlm.nih.gov/pubmed/6667333> Kabsch and Sander </a></li>
          <li>Reference 2: <a href=http://www.ncbi.nlm.nih.gov/pubmed/22877863> BioJava </a></li>
        </ul>
      </div>
    </div>
      
    <div class="list">
      <h4>Modeller</h4>

      Modeller is a tool for homology modelling of protein structures.
      <ul>
        <li><a href=https://www.ncbi.nlm.nih.gov/pubmed/24573470>Reference</a></li>
        <li><a href=https://salilab.org/modeller/>Homepage</a></li>
      </ul>
    </div>

    <div class="dakrlist">
      <div class="list">
      <h4>Rosetta</h4>

      The Rosetta software suite includes algorithms for computational modeling and analysis of protein structures.
      <ul>
        <li><a href=https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3760476>Reference</a></li>
        <li><a href=https://www.rosettacommons.org/software>Homepage</a></li>
      </ul>
      
      </div>
    </div>

    <div class="list">
      <h4>Elastic Network Models</h4>

      Elastic Network Models (ENMs) are applications of Normal Mode Analysis (NMA) aimed to predict protein motions from their crystallographic three-dimensional coordinates. The two models used in LoopGrafter are Gaussian (GNM) and Anisotropic (ANM), as implemented in ProDy. ANM produces a better prediction of the directionality of motions, and thus is better suited for cross-correlation analysis. 
      <ul>
        <li>Reference 1: <a href=https://pubmed.ncbi.nlm.nih.gov/9218955/>GNM</a></li>
        <li>Reference 2: <a href=https://pubmed.ncbi.nlm.nih.gov/16928735/>ANM</a></li>
        <li>Reference 3: <a href=https://pubmed.ncbi.nlm.nih.gov/24849577/>ProDy</a></li>
      </ul>
    </div>
  </div>
  <RightInfoPanel />
  </div>
</template>

<script>

import RightInfoPanel from "../components/RightInfoPanel";

export default {
  components: {
    RightInfoPanel,
  },

  methods: {
 
  },
};

</script>

<style scoped>

.ack{
  text-align: left;
  padding-bottom: 1vh;
  /*margin: 5vh;*/
  /*font-weight: bold;*/
}

.dakrlist{
  text-align: left;
  background: #cecece;
  padding-top: 1vh;
  padding-bottom: 1vh;
}

.list{
  padding-left: 1vh;
  padding-right: 3vh;
}

@media (min-width: 950px) {
  .workspace-grid {
    display: grid;
    grid-template-columns: auto 340px;
  }
}

</style>